//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.TrackEventAction
import com.tixforgigs.apax.models.TrackEventCategory

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The track request
* 
* @param idsite The ID of the website we're tracking a visit/action for.
* @param rec Required for tracking, must be set to one, eg, &rec=1.
* @param sendImage send_image — If set to 0 (send_image=0) Matomo will respond with an HTTP 204 response code instead of a GIF image. This improves performance and can fix errors if images are not allowed to be obtained directly (eg Chrome Apps). Available since Matomo 2.10.0
* @param actionName (recommended) — The title of the action being tracked. For page tracks this is used as page title. If enabled in your installation you may use the category tree structure in this field. For example, “game / register new user” would then create a group “game” and add the item “register new user” in it.
* @param apiv (recommended) — The parameter &apiv=1 defines the api version to use (currently always set to 1)
* @param ca Stands for custom action. &ca=1 can be optionally sent along any tracking request that isn't a page view. For example it can be sent together with an event tracking request e_a=Action&e_c=Category&ca=1. The advantage being that should you ever disable the event plugin, then the event tracking requests will be ignored vs if the parameter is not set, a page view would be tracked even though it isn't a page view. For more background information check out #16570. Do not use this parameter together with a ping=1 tracking request.
* @param eA 
* @param eC 
* @param eN The event name. (eg. a Movie name, or Song name, or File name...)
* @param eV The event value. Must be a float or integer value (numeric), not a string.
* @param rand (recommended) — Meant to hold a random value that is generated before each request. Using it helps avoid the tracking request being cached by the browser or a proxy.
* @param url (recommended) — The full URL for the current action.
*/
@Serializable

data class TrackRequest (


      /* The ID of the website we're tracking a visit/action for. */
    @SerialName(value = "idsite") @Required val idsite: kotlin.Int,


      /* Required for tracking, must be set to one, eg, &rec=1. */
    @SerialName(value = "rec") @Required val rec: kotlin.Int = 1,


      /* send_image — If set to 0 (send_image=0) Matomo will respond with an HTTP 204 response code instead of a GIF image. This improves performance and can fix errors if images are not allowed to be obtained directly (eg Chrome Apps). Available since Matomo 2.10.0 */
    @SerialName(value = "send_image") @Required val sendImage: kotlin.Int = 0,


      /* (recommended) — The title of the action being tracked. For page tracks this is used as page title. If enabled in your installation you may use the category tree structure in this field. For example, “game / register new user” would then create a group “game” and add the item “register new user” in it. */
    @SerialName(value = "action_name") val actionName: kotlin.String? = null,


      /* (recommended) — The parameter &apiv=1 defines the api version to use (currently always set to 1) */
    @SerialName(value = "apiv") val apiv: kotlin.Int? = 1,


      /* Stands for custom action. &ca=1 can be optionally sent along any tracking request that isn't a page view. For example it can be sent together with an event tracking request e_a=Action&e_c=Category&ca=1. The advantage being that should you ever disable the event plugin, then the event tracking requests will be ignored vs if the parameter is not set, a page view would be tracked even though it isn't a page view. For more background information check out #16570. Do not use this parameter together with a ping=1 tracking request. */
    @SerialName(value = "ca") val ca: kotlin.Int? = null,


      @SerialName(value = "e_a") val eA: TrackEventAction? = null,


      @SerialName(value = "e_c") val eC: TrackEventCategory? = null,


      /* The event name. (eg. a Movie name, or Song name, or File name...) */
    @SerialName(value = "e_n") val eN: kotlin.String? = null,


      /* The event value. Must be a float or integer value (numeric), not a string. */
    @SerialName(value = "e_v") val eV: kotlin.Double? = null,


      /* (recommended) — Meant to hold a random value that is generated before each request. Using it helps avoid the tracking request being cached by the browser or a proxy. */
    @SerialName(value = "rand") val rand: kotlin.Int? = 1,


      /* (recommended) — The full URL for the current action. */
    @SerialName(value = "url") val url: kotlin.String? = null


) {




  }

